import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '4all-ui/components/Button';
import Radio from '4all-ui/components/Radio';
import { REASONS } from '../../../../../../helpers/constants';
import * as styles from './style';
import AlertIcon from '../../../../../../components/Icons/Alert';
import { getParentElement } from '../../../../../../helpers/modal';

const CancelModal = ({ close, putOrder, data, show }) => {
  const [reason, setReason] = useState({});

  const closeModal = () => {
    setReason({});
    close();
  };

  const confirmCancel = () => {
    putOrder(data.idOrder, {
      status: 200,
      idCancellationReason: reason.id,
    });
    close();
  };

  const disabledCancel = reason.id == null;

  return (
    <Modal
      ariaHideApp={false}
      isOpen={show}
      style={styles.customStyles}
      onRequestClose={closeModal}
      parentSelector={() => getParentElement()}
    >
      <styles.Container>
        <styles.Header>
          <AlertIcon size="70px" />

          <styles.Title>Você tem certeza?</styles.Title>
        </styles.Header>

        <styles.Content>
          <styles.Text>
            Para continuar, selecione o motivo
            <br />
            do cancelamento.
          </styles.Text>

          <styles.ReasonList>
            {REASONS.map(item => (
              <styles.ReasonItem key={item.id}>
                <Radio
                  id={`choice-${item.id}`}
                  name="choice"
                  checked={item.id === reason.id}
                  label={item.label}
                  onChange={() => setReason(item)}
                />
              </styles.ReasonItem>
            ))}
          </styles.ReasonList>
        </styles.Content>

        <styles.Footer>
          <Button className="close-button" secondary onClick={closeModal}>
            Fechar
          </Button>
          <Button className="confirm-button" disabled={disabledCancel} onClick={confirmCancel}>
            Cancelar o pedido
          </Button>
        </styles.Footer>
      </styles.Container>
    </Modal>
  );
};

CancelModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  putOrder: PropTypes.func,
  data: PropTypes.object,
};

export default CancelModal;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/CancelModal/index.js